import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import styles from './ProfileSettings.module.scss';

import { getEditSuggestions } from 'legacy/actions/userActions';
import { showModal } from 'legacy/actions/modalActions';

import BackButton from '../../../util/BackButton/BackButton';

import Personal from './Personal';
import Login from './Login';
import Privacy from './Privacy';

const getHashConfig = (t) => ({
  profile: {
    title: t('users:settings.tabs.personalInfo'),
    component: Personal
  },
  login: {
    title: t('users:settings.tabs.loginSecurity'),
    component: Login
  },
  privacy: {
    title: t('users:settings.tabs.privacy'),
    component: Privacy
  }
});

const ProfileSettings = ({
  user,
  router,
  getEditSuggestions,
  showModal
}) => {
  const { t } = useTranslation(['users']);
  
  useEffect(() => {
    getEditSuggestions();
  }, []);

  const [hasChanged, setHasChanged] = useState(false);

  const config = getHashConfig(t);

  const { query } = router;
  const { setting } = query;
  const activeView = config[setting] ? setting : 'profile';

  const onClick = (key) => {
    router.push(`/profile?view=settings&setting=${key}`);
  };

  const links = Object.entries(config).map(([key, value]) => (
    <div
      key={key}
      className={cn(styles.link, { [styles.active]: activeView === key })}
      onClick={() => onClick(key)}
    >
      {value.title}
    </div>
  ));

  const ActiveComponent = config[activeView].component;

  const goBack = () => {
    if (hasChanged) {
      showModal('CONFIRMATION', {
        action: () => router.back(),
        message: t('users:settings.confirmation.unsavedChanges'),
        actionText: t('users:settings.confirmation.leaveAnyways')
      });
    } else {
      router.back();
    }
  };

  return (
    <div id="profile-settings" className={cn('bn-container', styles.wrapper)}>
      <BackButton goBack={goBack} className={styles.back} />
      <div className={styles.accountSettings}>
        {t('users:settings.title.account')}
      </div>
      <div className={styles.row}>
        <div className={styles.sidebar}>{links}</div>
        <div className={styles.main}>
          <ActiveComponent
            user={user}
            hasChanged={hasChanged}
            setHasChanged={setHasChanged}
          />
        </div>
      </div>
    </div>
  );
};

export default withRouter(
  connect(null, { getEditSuggestions, showModal })(ProfileSettings)
);
